"use client";

import { useEffect, useState, useRef } from "react";

import { motion } from "framer-motion";

const infinityIcon = (
  <svg
    width="175"
    height="86"
    viewBox="0 0 175 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M171.345 59.7318C168.025 67.4597 162.51 74.0174 155.556 78.6592C152.096 80.9662 148.268 82.8012 144.159 84.0525C140.078 85.331 135.717 85.9987 131.215 85.9987C125.444 85.9987 119.901 84.8856 114.836 82.8552C114.412 82.6901 114.02 82.5243 113.627 82.3289C109.067 80.3556 104.901 77.576 101.328 74.2674C100.174 73.1843 99.0777 72.0444 97.9783 70.7659C96.0381 68.57 94.0402 66.0402 92.0973 63.4835C91.7041 62.9572 91.281 62.4006 90.8881 61.871C89.819 60.427 79.6012 45.6393 77.8011 42.9983C76.8998 41.6658 75.8307 40.1647 74.6762 38.525C74.4234 38.1639 74.1433 37.7731 73.863 37.3851C71.9476 34.6895 69.8093 31.8532 67.8389 29.3505C66.855 28.1019 65.8685 26.9348 65.0247 25.9604C64.1536 24.9615 63.3648 24.1552 62.8014 23.6262C60.3831 21.376 57.5386 19.5409 54.4168 18.2896C51.2922 17.0383 47.887 16.3435 44.284 16.3435C41.8079 16.3435 39.4167 16.6778 37.1663 17.2884C36.0122 17.5948 34.8853 17.9832 33.7886 18.4554C28.9465 20.4586 24.8103 23.8488 21.9111 28.1022C20.449 30.241 19.2946 32.5755 18.5062 35.0782C17.7473 37.5808 17.297 40.2191 17.297 42.9987C17.297 46.6956 18.0582 50.17 19.4074 53.3678C21.4631 58.1475 24.8956 62.2053 29.2021 65.0963C31.3675 66.543 33.7308 67.6533 36.2647 68.4324C38.7958 69.2114 41.4697 69.6535 44.284 69.6535C47.887 69.6267 51.2922 68.9587 54.4168 67.7101C57.5389 66.4319 60.3831 64.624 62.8014 62.3738C63.3648 61.8444 64.1536 61.0114 65.0247 60.0369C66.5444 58.2862 68.3446 56.0359 70.1475 53.6715C70.8509 52.727 71.5544 51.7825 72.2579 50.8107C74.9593 54.7003 79.6862 61.538 82.1623 65.0694C81.7419 65.626 81.3188 66.1795 80.8981 66.736C79.7711 68.1558 78.6446 69.5156 77.5207 70.7669C76.3938 72.0454 75.3246 73.1853 74.1705 74.2685C70.2875 77.8842 65.7009 80.8289 60.6631 82.8566C55.5981 84.887 50.0525 86 44.284 86C38.2902 86 32.5492 84.803 27.3166 82.6072C19.4927 79.3553 12.8777 73.9076 8.17796 67.0431C5.84222 63.6228 3.98701 59.8174 2.69255 55.7865C1.42595 51.7274 0.75 47.4468 0.75 42.998C0.75 37.078 1.95916 31.4077 4.15523 26.2668C7.47483 18.5118 12.9905 11.9783 19.9134 7.33679C23.4036 5.02949 27.232 3.19747 31.3404 1.91895C35.4212 0.667625 39.7828 0 44.2843 0C50.0528 0 55.5987 1.11304 60.6634 3.14041C65.7013 5.1708 70.2603 8.11619 74.1437 11.7017L74.1709 11.7289C75.3253 12.7848 76.3945 13.9546 77.521 15.2331C79.4612 17.429 81.4592 19.9562 83.402 22.5132C83.7952 23.0425 84.2183 23.5718 84.6112 24.0985C85.6804 25.5724 99.6687 45.835 100.82 47.4743C101.076 47.8355 101.356 48.2235 101.636 48.6142C103.552 51.2827 105.69 54.1458 107.66 56.6458C108.644 57.8971 109.631 59.0645 110.475 60.0363C111.346 61.0379 112.135 61.8441 112.698 62.3731C115.116 64.6234 117.961 66.4312 121.083 67.7094C121.844 68.0135 122.603 68.2629 123.391 68.5156C125.867 69.2373 128.483 69.6257 131.215 69.6528C134.958 69.626 138.504 68.9037 141.71 67.5412C146.55 65.5407 150.689 62.1506 153.586 57.8971C155.05 55.7556 156.204 53.4211 156.99 50.9215C157.779 48.4189 158.202 45.7779 158.202 42.9983C158.202 39.3014 157.441 35.7998 156.092 32.6322C154.036 27.8525 150.604 23.7645 146.297 20.9037C144.132 19.457 141.769 18.3168 139.235 17.5676C136.731 16.7886 134.03 16.3431 131.215 16.3431C127.612 16.3431 124.207 17.0379 121.083 18.2893C117.96 19.5406 115.116 21.3756 112.698 23.6259C112.134 24.1552 111.345 24.9883 110.474 25.96C108.955 27.6836 107.152 29.9638 105.352 32.3251C104.621 33.27 103.917 34.2444 103.214 35.2161C102.988 34.8825 102.763 34.5482 102.51 34.1873C97.8658 27.4611 94.9387 23.208 93.3363 20.9034C93.7567 20.3468 94.1802 19.8175 94.6006 19.261C95.7275 17.8442 96.8541 16.4814 97.9779 15.2331C99.077 13.9549 100.174 12.7848 101.328 11.7289C105.211 8.1162 109.798 5.1708 114.836 3.14041C119.901 1.11304 125.444 0 131.215 0C137.208 0 142.95 1.19427 148.155 3.36295C156.006 6.64199 162.619 12.0897 167.321 18.9569C169.654 22.3742 171.542 26.1554 172.806 30.2135C174.074 34.2444 174.75 38.5519 174.75 42.998C174.75 48.918 173.541 54.5882 171.345 59.7318Z"
      fill="url(#paint0_linear_869_22)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_869_22"
        x1="20.84"
        y1="75.4105"
        x2="72.9844"
        y2="42.0859"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3DFDE" />
        <stop offset="1" stop-color="#AEB7CD" />
      </linearGradient>
    </defs>
  </svg>
);

function easingFunction(x: number) {
  return x;
}

interface CounterProps {
  start?: number;
  end: number;
  duration?: number;
}

const Counter = ({ start = 0, end, duration = 2000 }: CounterProps) => {
  const [count, setCount] = useState(start);
  const [hasAnimated, setHasAnimated] = useState(false);
  const [isInView, setIsInView] = useState(false);

  const elementRef = useRef<HTMLElement | null>(null);
  const animationFrameId = useRef<number | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    if (!isInView || hasAnimated) return;

    const startTime = performance.now();

    function updateCounter(currentTime: number) {
      const elapsed = currentTime - startTime;
      if (elapsed < duration) {
        const progress = easingFunction(elapsed / duration);
        setCount(Math.floor(start + progress * (end - start)));
        animationFrameId.current = requestAnimationFrame(updateCounter);
      } else {
        setCount(end);
        setHasAnimated(true);
      }
    }

    animationFrameId.current = requestAnimationFrame(updateCounter);

    return () => {
      if (animationFrameId.current !== null) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, [start, end, duration, isInView, hasAnimated]);

  useEffect(() => {
    elementRef.current = document.querySelector(".module-statistics");

    if (!elementRef.current) return;

    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0]) {
          setIsInView(entries[0].isIntersecting);
        }
      },
      { threshold: 0.1 },
    );

    observerRef.current.observe(elementRef.current);

    return () => {
      if (observerRef.current && elementRef.current) {
        observerRef.current.unobserve(elementRef.current);
        observerRef.current.disconnect();
      }
    };
  }, []);

  function formatNumber(value: number) {
    if (value >= 1_000_000_000)
      return (
        <span className="flex h-[150px] items-center text-[200px] leading-[0.5]">
          {infinityIcon}
        </span>
      );
    if (value >= 1_000_000) return (value / 1_000_000).toFixed(0) + "M+";
    if (value >= 1_000) return (value / 1_000).toFixed(0) + "k+";
    return value + "+";
  }

  return <span translate="no">{formatNumber(count)}</span>;
};

const StatisticsSection = () => {
  const stats = [
    {
      value: 3_000,
      label: "Surveys Generated",
    },
    {
      value: 50_000,
      label: "Insights Gathered",
    },
    {
      value: 5,
      label: "AI Agents Integrated",
    },
    {
      value: 1000_000_000,
      label: "Possibilities",
    },
  ];

  return (
    <section className="module-statistics mx-auto max-w-1440 px-6 lg:px-24">
      <div className="grid grid-cols-2 justify-items-center gap-x-10 xl:grid-cols-4">
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="flex flex-col text-center xl:text-left"
          >
            <motion.p
              initial={{ scale: 0.5 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-[linear-gradient(108deg,_#F3DFDE_11.73%,_#AEB7CD_43.81%)] bg-clip-text text-[100px] font-semibold text-transparent"
            >
              <Counter start={1} end={stat.value} />
            </motion.p>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 + 0.2 }}
              viewport={{ once: true }}
              className="text-center text-[18px] leading-[1.5] text-white/60"
            >
              {stat.label}
            </motion.p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default StatisticsSection;
